import styled from '@emotion/styled'
import { Stack } from 'components/Stack'
import { colors } from 'utils/colors'
import { BREAKPOINTS } from 'utils/styled'

export const SDashboardSectionPlaceholder = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: ${colors.gray[300]};
  padding: 2.5rem 1rem;
  text-align: center;
  gap: 1rem;
`
export const SStack = styled(Stack)`
  @media ${BREAKPOINTS.MD.max} {
    width: 100%;
  }
`
